/*
 * @Description: vuex方法引入
 * @Author: zml
 * @Date: 2022-10-27 09:06:05
 * @LastEditors: zml
 * @LastEditTime: 2023-04-27 12:30:13
 */
export const SET_TENANTINFO = 'set_tenantInfo' //设置用户信息
export const DEL_TENANTINFO = 'del_tenantInfo'
export const SET_SETTING = 'set_setting' // 获取网站配置
export const TENANTID = '' //体验 288762652057669 // 142307070918780

